import { ORGANIZATION, SITE_NAME, SITE_NAME_EN } from '@/seo/constants';
import termsMarkdown from '!!raw-loader!./terms.md';
import privacyMarkdown from '!!raw-loader!./privacy.md';
import aboutMarkdown from '!!raw-loader!./about.md';

export const DEFAULT_CONTACT = {
    email: ORGANIZATION.email,
    whatsapp: ORGANIZATION.telephone,
    website: 'codingwithghonaim.com',
    websiteHref: ORGANIZATION.url,
};

const pages = {
    terms: {
        slug: 'terms',
        title: 'شروط الاستخدام',
        subtitle: SITE_NAME,
        lastUpdated: '2026-09-29',
        contentMarkdown: termsMarkdown,
        seoTitle: `شروط الاستخدام | ${SITE_NAME}`,
        seoDescription:
            'اقرأ شروط استخدام منصة البرمجة مع غنيم، قواعد الاشتراك، استخدام المحتوى، وحقوق ومسؤوليات الطلاب وأولياء الأمور.',
        showToc: true,
        showContact: true,
        layout: 'legal',
        apiPath: '/terms',
        contact: DEFAULT_CONTACT,
    },
    privacy: {
        slug: 'privacy',
        title: 'سياسة الخصوصية',
        subtitle: SITE_NAME,
        lastUpdated: '2026-05-27',
        contentMarkdown: privacyMarkdown,
        seoTitle: `سياسة الخصوصية | ${SITE_NAME}`,
        seoDescription:
            'تعرف على سياسة الخصوصية في البرمجة مع غنيم وكيفية التعامل مع بيانات الطلاب وأولياء الأمور داخل المنصة.',
        showToc: true,
        showContact: true,
        layout: 'legal',
        apiPath: '/privacy',
        contact: DEFAULT_CONTACT,
    },
    about: {
        slug: 'about',
        title: 'من نحن',
        subtitle: SITE_NAME_EN,
        lastUpdated: null,
        contentMarkdown: aboutMarkdown,
        seoTitle: `من هو محمد غنيم؟ | ${SITE_NAME}`,
        seoDescription:
            'تعرف على محمد غنيم، مؤسس البرمجة مع غنيم، وخبرته في التعليم، التكنولوجيا، الذكاء الاصطناعي، وبناء المنصات التعليمية.',
        showToc: true,
        showContact: false,
        layout: 'story',
        apiPath: '/about',
        heroImage: require('@/assets/welcome/ghonaim-portrait.webp'),
        heroImageAlt: 'محمد غنيم — مؤسس البرمجة مع غنيم',
    },
};

pages['privacy-policy'] = pages.privacy;

export function getContentPage(slug) {
    return pages[slug] ? { ...pages[slug] } : null;
}

export function listContentPages() {
    return ['terms', 'privacy', 'about'].map((slug) => getContentPage(slug));
}
